import React from 'react';

const TimelineDocumentIcon = ({ fill = 'grey'}) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 14 11.2"
      xmlSpace="preserve"
      className="card-icon"
    >
      <desc>Created with Sketch.</desc>
      <g id="Case-Details---New">
        <g id="Case-Details---Timeline" transform="translate(-575.000000, -2097.000000)">
          <g id="Timeline" transform="translate(255.000000, 777.000000)">
            <g id="Timeline-Items" transform="translate(277.000000, 107.000000)">
              <g id="Stage-Updated" transform="translate(0.000000, 1193.000000)">
                <g id="Icon" transform="translate(31.000000, 0.000000)">
                  <g id="Avatar">
                    <g id="project-diagram-regular" transform="translate(12.000000, 20.000000)">
                      <path
                        id="Shape"
                        fill={fill}
                        d="M13.3,0h-2.8c-0.4,0-0.7,0.3-0.7,0.7v0.7H4.2V0.7C4.2,0.3,3.9,0,3.5,0H0.7
                        C0.3,0,0,0.3,0,0.7v2.8c0,0.4,0.3,0.7,0.7,0.7h2.1l2.1,3.7v2.6c0,0.4,0.3,0.7,0.7,0.7h2.8c0.4,0,0.7-0.3,0.7-0.7V7.7
                        C9.1,7.3,8.8,7,8.4,7H6L4.2,3.8v-1h5.6v0.7c0,0.4,0.3,0.7,0.7,0.7h2.8c0.4,0,0.7-0.3,0.7-0.7V0.7C14,0.3,13.7,0,13.3,0z
                        M3.2,3.2H1V1h2.1V3.2z M5.9,8.1h2.1v2.1H5.9V8.1z M12.9,3.2h-2.1V1h2.1V3.2z"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default TimelineDocumentIcon;
